<template>
  <div>
    <!-------------Start toast / snackbar --------------------------->
    <!-- <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" /> -->
    <!-------------end toast / snackbar --------------------------->
    <router-link to="/seminars">
      <div class="d-flex">
        <v-icon>mdi-arrow-left-thin</v-icon>
        <span class="mx-3" style="color: rgba(34, 34, 34, 0.7)">Seminars</span>
      </div>
    </router-link>
    <div class="d-flex justify-space-between mt-9 align-center">
      <div class="heading-1">Students</div>
      <div>
        <!-- <v-btn color="primary" depressed @click="addStudentdialog = true"
          ><span class="text_style px-8 py-3">+ Add student</span></v-btn
        > -->
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="pa-0 ma-0 ml-3"
              depressed
              color="transparent"
            >
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <div
              v-if="
                GetStudents.Data?.RoyaltyAgreementFee ||
                GetStudents.Data?.ManualFee?.DigitalManualInstructorFee
              "
            >
              <v-list-item
                v-if="isManualPayment"
                @click="RoyaltyManualPayment('Manual')"
              >
                <v-list-item-title>
                  <v-icon class="mr-3">mdi-book-open-variant</v-icon>
                  <span>Manual Payment</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="isRoyaltyPayment"
                @click="RoyaltyManualPayment('Royalty')"
              >
                <v-list-item-title>
                  <v-icon class="mr-3">mdi-currency-usd</v-icon>
                  <span>Royalty Payment </span>
                </v-list-item-title>
              </v-list-item>
            </div>
            <v-list-item @click="GraduateStudent()">
              <v-list-item-title>
                <v-icon class="mr-3">mdi-school</v-icon>
                <span>Graduate Students </span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="EmailStudentDialog = true">
              <v-list-item-title>
                <v-icon class="mr-3">mdi-email</v-icon>
                <span>Email Students</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="cursor-pointer">
              <v-list-item-title>
                <VueBlobJsonCsv
                    file-type="csv"
                    file-name="Bulk Download Students"
                    :data="GetStudents.Data?.Students"
                  >
                    <v-icon class="mr-3">mdi-export</v-icon>
                    <span>Export list</span>
                  </VueBlobJsonCsv>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="cursor-pointer" @click="openCopyStudentEmailsDialog">
              <v-list-item-title>
                <v-icon class="mr-3">mdi-content-copy</v-icon>
                <span>Copy Student Emails</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <!--------- data table ------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetStudents.Data?.Students"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.Monitor`]="{ item }">
          <span class="table_style_one">
            {{ item.Monitor ? "Yes" : "No" }}
          </span>
        </template>
        <template v-slot:[`item.RegistrationDate`]="{ item }">
          <span class="table_style_one">
            {{ item.RegistrationDate?.split("T")[0].replaceAll("-", "/") }}
          </span>
        </template>
        <template v-slot:[`item.PaidAmount`]="{ item }">
          <span class="table_style_one" v-if="item.ManualPaidDate">
            {{ item.ManualPaidDate?.split("T")[0].replaceAll("-", "/")}}
          </span>
          <span class="table_style_one" v-else>
            {{ item.Monitor ? "Not Required" : "" }}
          </span>
        </template>
        <template v-slot:[`item.GraduationDate`]="{ item }">
          <span class="table_style_one">
            {{ item.GraduationDate?.split("T")[0].replaceAll("-", "/") }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu
            transition="scroll-y-transition"
            offset-y
            color="transparent"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat class="py-2">
              <v-list class="px-3 py-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="openStudentDialog(item)"
                >
                  <v-icon color="#646464">mdi-account</v-icon>
                  <span class="ml-4 text_style">Student Info</span>
                </v-btn>
              </v-list>
              
              <v-list v-if="!item.GraduationDate" class="px-3 py-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="deleteStudent(item)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="my-5 pa-3 d-flex justify-end" flat color="#ECF1F2">
      <div class="mx-2">
        <b>TOTALS:</b>
      </div>
      <div class="mx-2">
        <span>Students: {{ GetStudents.Data?.TotalRecords }}</span>
      </div>
      
      <div class="mx-2">
        <span>Monitor: {{ GetStudents.Data?.TotalMonitors }}</span>
      </div>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @change="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination
    ></v-card>
    <!-- Student Info Dialog -->
    <v-dialog v-model="studentInfoDialog" max-width="500px" persistent>
      <v-card class="px-7 py-4">
        <div class="d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 24px"
              ><b>Student Info</b></span
            >
          </div>
        </div>

        <v-card-text v-if="selectedStudent" class="px-2 py-4" style="font-size: 16px">
          <div class="my-1"><b>Email:</b> 
            <a :href="`mailto:${selectedStudent.Email}`" class="text-decoration-none">
              {{ selectedStudent.Email }}
            </a>
          </div>
          <div class="my-1"><b>Phone:</b> {{ selectedStudent.Phone }}</div>
          <div class="my-1"><b>Country:</b> {{ selectedStudent.Country }}</div>
        </v-card-text>

        <v-card-actions class="px-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="studentInfoDialog = false" class="px-4">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!----------Edit dialog------------------>
    <v-dialog v-model="editdialog" persistent max-width="600">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit desgin are not avaiable</h5>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <!-- <edit-vedio-component /> -->
        </div>
        <div class="d-flex justify-end mx-5 py-5">
          <v-btn
            class="px-14 py-6 text_style"
            color="#A1A3A8"
            text
            @click="editdialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="primary" class="px-14 py-6 text_style" @click="send()">
            <span class="text_style" v-if="btnloader != true">Save</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!----------Delete dialog------------------>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card class="pa-8">
        <div class="my-2" style="font-size: 18px;text-align: center;">
          <b>
            Are you sure you want to remove {{ studentName }}?</b
          >
        </div>
        <div class="d-flex justify-center">
          <v-card-actions>
            <v-btn
              color="primary"
              class="py-5"
              depressed
              outlined
              @click="dialog = false"
            >
              <span class="text_style"> Don’t Remove</span>
            </v-btn>
            <v-btn
              color="primary"
              class="py-5 px-4"
              depressed
              @click="DdialogClose()"
              :disabled="btnloader"
            >
              <span class="text_style" v-if="btnloader != true">Remove</span>
              <v-progress-circular
                v-else
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <!------------------Add new Student---------------------->
    <v-dialog v-model="addStudentdialog" persistent max-width="450">
      <v-card class="pt-7 pb-4">
        <div class="px-7 d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 24px"><b>Add new student</b></span>
          </div>
          <div>
            <v-icon @click="addStudentdialog = false">mdi-close</v-icon>
          </div>
        </div>
        <v-card class="px-7 pa-5 mt-5" flat color="#E5E5E5">
          <v-select
            :items="selectStudentForSeminarArray"
            single-line
            v-model="selectStudentForSeminar"
            prepend-inner-icon="mdi-magnify"
            label="Search Student..."
          ></v-select>
        </v-card>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>

          <v-btn color="transparent" depressed @click="addStudentdialog = false"
            ><span class="text_style">Cancel</span></v-btn
          >
          <v-btn
            color="primary"
            class="px-14 py-4 ml-5"
            depressed
            :disabled="btnloader"
            @click="send()"
            ><span v-if="btnloader != true"> Add </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!------------------EmailStudentDialog dialog------------------------------------>
    <v-dialog v-model="EmailStudentDialog" persistent max-width="550">
      <v-card class="pt-7 pb-4">
        <div class="px-7 d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 24px"
              ><b>Email students of your seminar</b></span
            >
          </div>
          <div>
            <v-icon @click="closeEmailModule()">mdi-close</v-icon>
          </div>
        </div>
        <v-card class="px-7 pa-5 mt-5" flat color="transparent">
          <v-text-field
            label="Subject"
            single-line
            v-model="emailForm.Subject"
            :error-messages="
              $v.emailForm.Subject.$error ? 'Subject is required' : null
            "
          ></v-text-field>
          <v-textarea
            name="input-7-1"
            label="Body"
            value=""
            single-line
            v-model="emailForm.Body"
            :error-messages="$v.emailForm.Body.$error ? 'Body is required' : null"
          ></v-textarea>
        </v-card>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>

          <v-btn
            color="transparent"
            depressed
            @click="closeEmailModule()"
            ><span class="text_style text_transform">Cancel</span></v-btn
          >
          <v-btn
            color="primary"
            class="px-14 py-4 ml-5"
            depressed
            @click="checkValidateState()"
            ><span v-if="btnloader != true" class="text_style text_transform">
              Preview email
            </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!----------------Preview--EmailStudentDialog dialog------------------------------------>
    <v-dialog v-model="PreviewEmailStudentDialog" persistent max-width="550">
      <v-card class="pt-7 pb-4">
        <div class="px-7 d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 24px"
              ><b>Email students of your seminar</b></span
            >
          </div>
          <div>
            <v-icon @click="closeEmailModule()"
              >mdi-close</v-icon
            >
          </div>
        </div>
        <v-card class="px-7 pa-5 mt-5" flat color="transparent">
          <div class="d-flex align-center">
            <div class="grey--text mr-4">Subject:</div>
            {{ emailForm.Subject }}
          </div>
          <div class="mt-5 mb-3">Body</div>
          <div>
            {{ emailForm.Body }}
          </div>
        </v-card>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>

          <v-btn
            color="transparent"
            depressed
            @click="
              PreviewEmailStudentDialog = false;
              EmailStudentDialog = true;
            "
            ><span class="text_style text_transform">Back</span></v-btn
          >
          <v-btn
            color="primary"
            class="px-14 py-4 ml-5"
            depressed
            :disabled="btnloader"
            @click="send()"
            ><span v-if="btnloader != true" class="text_style text_transform">
              Send email
            </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Copy Student Emails Dialog -->
    <v-dialog v-model="CopyStudentEmailsDialog" persistent max-width="600">
      <v-card class="py-2 pa-md-4">
        <div class="px-7 pt-4 d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 22px"
              ><b>Copy student emails</b></span
            >
          </div>
          <div>
            <v-icon @click="CopyStudentEmailsDialog = false">mdi-close</v-icon>
          </div>
        </div>
        <div class="px-7 pt-4">
          <p>To email your students directly, copy the addresses in the yellow box below and paste them into the <b>Bcc:</b> field of your email program. Always use <b>Bcc:</b> so student emails remain private.</p>
        </div>
        
        <div class="px-7 py-4">
          <v-card class="yellow-box pa-4" outlined color="#FFF9C4" style="border: 1px solid #FFD54F;">
            <div ref="emailList" class="email-list" style="white-space: pre-line;">
              {{ formattedEmailList }}
            </div>
          </v-card>
        </div>
        
        <v-card-actions class="px-7 pb-4 d-flex justify-end">
          <v-btn 
            color="primary" 
            depressed 
            @click="copyWithModernAPI"
            class="px-4"
          >
            COPY
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!------------------Graduate Students dialog------------------------------------>
    <v-dialog v-model="GraduateStudentDialog" persistent max-width="1400">
      <v-card class="pt-9 pb-0">
        <div class="px-9 d-flex justify-space-between align-center">
          <div>
            <span style="font-size: 24px"><b>Graduate Students</b></span>
            <div class="mt-7">
              Only Monitors or students for whom the digital Manual fee or royalty fee have<br />been paid can be graduated.
            </div>
          </div>

          <div>
            <v-icon @click="GraduateStudentDialog = false">mdi-close</v-icon>
          </div>
        </div>
        <v-card class="px-9 pa-5" flat color="transparent">
          <v-card outlined>
            <v-data-table
              :headers="headerGraduateStudent"
              :loading="tableLoader"
              loading-text="Loading... Please wait"
              :items="filteredStudents"
              :page.sync="page"
              :items-per-page="displayedItemsPerPage"
              @page-count="pageCount = $event"
              hide-default-footer
            >
              <template v-slot:[`item.Name`]="{ item }">
                <span class="table_style_one notranslate"> {{ item.Name }} </span>
              </template>
              <template v-slot:[`item.RegistrationDate`]="{ item }">
                <span class="table_style_one">
                  {{ item.RegistrationDate?.split("T")[0].replaceAll("-", "/") }}
                </span>
              </template>
              <template v-slot:[`item.Monitor`]="{ item }">
                <span class="table_style_one">
                  {{ item.Monitor ? "Yes" : "No" }}
                </span>
              </template>
              <template v-slot:[`item.ManualPaid`]="{ item }">
                <span class="table_style_one">
                  {{ item.ManualPaid ? "Yes" : "No" }}
                </span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-checkbox
                  v-if="
                    item.ManualPaid ||
                    item.Monitor ||
                    (!GetStudents.Data?.RoyaltyAgreementFee &&
                      !GetStudents.Data?.ManualFee?.DigitalManualInstructorFee)
                  "
                  v-model="selectedStudentCheckbox"
                  :value="item.StudentId"
                ></v-checkbox>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
        <v-card-actions class="px-8 pb-10 d-flex justify-end gap-2">
          <v-btn
            color="primary"
            outlined
            depressed
            @click="GraduateStudentDialog = false"
            ><span class="text_style">Cancel</span></v-btn
          >
          <v-btn
            color="primary"
            class="graduate-btn py-4"
            depressed
            :disabled="btnloader"
            @click="handleGraduateStudents()"
            ><span v-if="btnloader != true" class="text_style"> Graduate </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="SuccessGraducatedDialog"
      persistent
      max-width="450"
    >
      <v-card class="seminar">
        <div class="d-flex justify-end pa-5">
          <v-icon @click="SuccessGraducatedDialog = false">mdi-close</v-icon>
        </div>

        <div class="px-6 py-3 d-flex justify-center align-center">
          <span class="font--24"> Your students are now graduated. </span>
        </div>
        <div class="px-6 py-3 pb-0 font-Primary-24">
          Close this window or go back to your seminar page.
        </div>
        <v-card-actions class="d-flex justify-center">
          <div class="px-8 py-7">
            <v-btn
              color="primary"
              :disabled="btnloader"
              to="/seminars"
              depressed
              >
              <span v-if="btnloader != true">My seminars</span>
              <v-progress-circular
                v-else
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openNextDialog"
      persistent
      max-width="550"
    >
      <v-card class="py-7 px-10">
        <div class="d-flex justify-end mb-2">
          <v-icon @click="openNextDialog = false"
            >mdi-close</v-icon
          >
        </div>
        <div class="d-flex justify-center text-center">
          <p
            style="
              font-family: Noto Serif;
              font-weight: 700;
              font-size: 1.5rem;
            "
          >
            Do you want to mark the manual/royalty as paid for these Users? 
          </p>
        </div>
        <div class="d-flex justify-center">
          <p
            class="primary--text"
            style="
              font-family: Noto Serif;
              font-weight: 700;
              font-size: 1.5rem;
              text-align: center;
            "
          >
            It will not generate any order or invoice. 
          </p>
        </div>

        <div class="d-flex justify-center gap-3 mt-2">
          <v-btn color="primary" class="px-8" depressed @click="ManualRoyaltyPayment()">
            <span>Yes</span>
          </v-btn>
          <v-btn color="primary" class="px-8" depressed @click="openNextDialog = false">
            <span>No</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!------------------ManualPaymentDialog dialog------------------------------------>
    <v-dialog v-model="ManualPaymentDialog" persistent max-width="1100">
      <v-card class="pt-9 pb-0">
        <div v-if="stepOne">
          <div class="px-9 d-flex justify-space-between align-center">
            <div>
              <span style="font-size: 24px"
                ><b
                  >Purchase Digital Manuals
                  <!-- - {{ this.courseName }} -->
                </b></span
              >
            </div>
            <div>
              <v-icon @click="close">mdi-close</v-icon>
            </div>
          </div>
          <div class="px-9 py-3">
            <span>
              You must purchase a digital Manual for any student you plan to
              graduate, unless they are a monitor; otherwise, they cannot be
              graduated. Once purchased, students can access their digital
              Manuals in their User accounts. Manuals cannot be purchased prior
              to 7 (seven) days before the course starts.
            </span>
          </div>
          <div class="px-9 py-3">
            <span>
              <b> Note:</b> Digitals Manuals purchased before the course
              finishes are done so at your own risk. Manuals purchased for
              students who do not show up or who cannot be graduated will not be
              refunded.
            </span>
          </div>
          <!-- <div class="px-8 d-flex justify-end">
            <v-btn color="primary" depressed @click="SelectAllPurchaseDigital">
              Select All
            </v-btn>
          </div> -->
          <v-card class="px-9 pa-5" flat color="transparent">
            <v-card class="" outlined>
              <table
                class="w-100 PurchaseDigitalTable"
                style="border-collapse: collapse"
              >
                <tr style="border: 1px solid #f1f1f1">
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Student Name
                  </th>
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Membership Level
                  </th>
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Registration Date
                  </th>
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Monitor
                  </th>
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Manual Due
                  </th>
                  <th
                    class="px-5 py-5"
                    style="color: #00000085; font-size: 0.8rem"
                  >
                    Purchase
                  </th>
                </tr>
                <tr
                  class="px-5 py-5"
                  v-for="(item, i) in allStudentsForManualPayment"
                  :key="i"
                  style="border: 1px solid #f1f1f1"
                >
                  <td class="px-5 py-5">
                    <b class="table_style_one"> {{ item.Name }} </b>
                  </td>
                  <td class="px-5 table_style_one">
                    {{ item.MembershipLevel }}
                  </td>
                  <td class="px-5 table_style_one">
                    {{
                      item.RegistrationDate.split("T")[0].replaceAll("-", "/")
                    }}
                  </td>
                  <td class="px-5 table_style_one">
                    {{ item.Monitor ? "Yes" : "No" }}
                  </td>
                  <td class="px-5 table_style_one">
                    <span v-if="!item.Monitor">Yes</span>
                    <span v-else>
                      {{ item.ManualPaid ? "Yes" : "No" }}
                    </span>
                  </td>
                  <td class="px-5">
                    <v-checkbox
                      v-if="item.ManualPaid == false && item.Monitor == false"
                      v-model="PurchaseDigitalManualsCheckBox"
                      :value="item.StudentId"
                    ></v-checkbox>
                    <v-icon v-else>mdi-check</v-icon>
                  </td>
                </tr>
                <!-- <tr>
                  <td></td>
                  <td></td>
                  <td class="px-5 py-5"><b> Total: 6 </b></td>
                  <td class="px-5 py-5"><b>Total: 2 </b></td>
                </tr> -->
              </table>
            </v-card>
            <template>
              <div class="mt-4">
                <span style="font-weight: bold">
                  Manual Cost:
                  {{ GetStudents.Data?.ManualFee?.DigitalManualInstructorFee }}
                  USD</span
                >
              </div>
              <div class="">
                <span style="font-weight: bold">
                  Total Cost: {{ totalManualCost }} USD</span
                >
              </div>
            </template>
          </v-card>
          <v-card-actions class="px-8 pb-10 d-flex justify-space-between">
            <div class=" ">
              <div class="">
                <span> To proceed, click CHECKOUT.</span>
              </div>
              <div class="">
                <span
                  >After payment, students will receive their digital
                  Manual.</span
                >
              </div>
            </div>
            <div class="d-flex justify-end">
              <v-btn
                color="transparent"
                depressed
                @click="close"
                ><span class="text_style">Cancel</span></v-btn
              >
              <v-btn
                color="primary"
                class="px-14 py-4 ml-5"
                depressed
                @click="openNextProcessDialog('manual')"
                ><span v-if="btnloader != true" class="text_style"> Next </span>
                <!-- @click="GoToStepTwo('manual')" -->
                <v-progress-circular
                  indeterminate
                  size="20"
                  v-else
                  class="px-5"
                  color="white"
                  v-show="btnloader"
                ></v-progress-circular
              ></v-btn>
            </div>
          </v-card-actions>
        </div>
        <div v-show="stepTwo" class="px-6 py-2">
          <div class="d-flex justify-space-between align-center mb-6">
            <div>
              <span style="font-size: 24px">Billing Address</span>
            </div>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <v-row class="pa-2" style="display: flex; flex-wrap: wrap">
            <v-col cols="12" lg="7" md="7" class="ordering-payments" style="">
              <v-card max-width="550" flat>
                <v-row class="mt-4">
                  <v-col cols="12" md="6">
                    <p><b> First Name</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.FirstName"
                      :error-messages="
                        $v.form.BillingDetails.FirstName.$error
                          ? form.BillingDetails.FirstName == ''
                            ? 'First Name is required'
                            : 'First Name only contain alphabetic characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>Last Name</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.LastName"
                      :error-messages="
                        $v.form.BillingDetails.LastName.$error
                          ? form.BillingDetails.LastName == ''
                            ? 'Last Name is required'
                            : 'Last Name only contain alphabetic characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <p><b>Street Address</b></p>
                <v-text-field
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  v-model="form.BillingDetails.StreetAddress1"
                  :error-messages="
                    $v.form.BillingDetails.StreetAddress1.$error
                      ? 'Street Address is required'
                      : null
                  "
                >
                </v-text-field>
                <v-text-field
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  v-model="form.BillingDetails.StreetAddress2"
                >
                </v-text-field>
                <v-row class="my-0 py-0">
                  <v-col cols="12" md="6">
                    <p><b> City</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.City.$error
                          ? form.BillingDetails.City == ''
                            ? 'City is required'
                            : 'City only contain alphabetic characters'
                          : null
                      "
                      v-model="form.BillingDetails.City"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>State / Province / Region</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.Province.$error
                          ? 'State or Province is required'
                          : null
                      "
                      v-model="form.BillingDetails.Province"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <p><b> Zip Code</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.ZipCode"
                      :error-messages="
                        $v.form.BillingDetails.ZipCode.$error
                          ? form.BillingDetails.ZipCode == ''
                            ? 'Zip Code is required'
                            : 'Zip Code only contain alphabetic and numeric characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>Country / Region</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.Country.$error
                          ? 'Country is required'
                          : null
                      "
                      v-model="form.BillingDetails.Country"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <div class="mt-8"><b>Phone Number</b></div>
                <v-text-field
                  single-line
                  outlined
                  class="mt-5"
                  flat
                  solo
                  dense
                  maxlength="17"
                  minlength="7"
                  v-model="form.BillingDetails.PhoneNumber"
                  :error-messages="
                    getErrorMessage('PhoneNumber', 'PhoneNumber')
                  "
                >
                </v-text-field>
                <v-divider class="divider mt-9"></v-divider>
                <div class="my-8" style="font-size: 24px">
                  <b>Credit Card Information</b>
                </div>
                <div>
                  <v-row>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Name on Card:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            dense
                            outlined
                            :error-messages="
                              getErrorMessageCardHolderName(
                                form.PaymentCard.CardHolderName
                              )
                            "
                            v-model="form.PaymentCard.CardHolderName"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Card Number:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            maxlength="16"
                            :error-messages="
                              getErrorMessageCardNumber(
                                form.PaymentCard.CardNumber
                              )
                            "
                            v-model="form.PaymentCard.CardNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="my-7">
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">CVV Code:</div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            :maxlength="form.PaymentCard.CardNumber?.length === 15 ? 4 : 3"
                            :error-messages="
                              getErrorCardNumberCvv(form.PaymentCard.CardCVV)
                            "
                            v-model="form.PaymentCard.CardCVV"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Expiration Date:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            class=""
                            label="MM/YY"
                            maxlength="5"
                            dense
                            outlined
                            single-line
                            v-model="form.PaymentCard.CardExp"
                            @input="formatExpiryDate"
                            :error-messages="
                              getErrorMessageExpiryDate(
                                form.PaymentCard.CardExp
                              )
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
                <div class="d-flex justify-space-between mt-11">
                  <div>
                    <v-btn
                      color="primary"
                      class="px-9"
                      v-show="this.stepTwo == true"
                      @click="GoBack()"
                      >Back</v-btn
                    >
                  </div>
                  <div>
                    <v-btn
                      color="primary"
                      :disabled="submitBtnloader"
                      class="px-9"
                      @click="Submit()"
                      ><span v-if="submitBtnloader != true">Submit</span
                      ><v-progress-circular
                        indeterminate
                        size="20"
                        v-else
                        class="px-5"
                        color="white"
                        v-show="submitBtnloader"
                      ></v-progress-circular
                    ></v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="5" md="5" class="ordering-summary" style="">
              <v-card flat outlined>
                <span class="pt-4 d-flex justify-center head-primary"
                  >MANUAL DETAILS</span
                >
                <v-divider class="devider"></v-divider>
                <span class="mx-5 d-flex font-18 mb-2" style="font-weight: bold"
                  >Manual Amount:
                  {{ form.TotalAmount }}
                </span>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <!------------------Royal dialog------------------------------------>
    <v-dialog v-model="GraduateDialog" persistent max-width="1100">
      <v-card class="pt-9 pb-0">
        <div v-if="stepOne">
          <div class="px-9 d-flex justify-space-between align-center">
            <div>
              <span style="font-size: 24px"
                ><b
                  >Pay royalties
                  <!-- - {{ this.courseName }} -->
                </b></span
              >
            </div>
            <div>
              <v-icon @click="close">mdi-close</v-icon>
            </div>
          </div>
          <div class="px-9 py-3">
            <span>
              You must pay royalties for any student you plan to graduate;
              otherwise, they cannot be graduated. If there is a digital Manual
              for the course, students will receive the Manual in their User
              account once royalty fees as paid. Royalties cannot be paid prior
              to 7 (seven) days before the course starts.
            </span>
          </div>
          <div class="px-9 py-3">
            <span>
              <b>Note:</b> Royalties paid before the course finishes are done so
              at your own risk. Royalties paid for students who do not show up
              or who cannot be graduated will not be refunded.
            </span>
          </div>
          <div>
            <!-- <div class="px-8 d-flex justify-end mt-6">
              <v-btn color="primary" @click="SelectAllPayRoyalties" depressed>
                Select All
              </v-btn>
            </div> -->
            <v-card class="px-9 pa-5" flat color="transparent">
              <v-card outlined>
                <v-data-table
                  :headers="PayRoyalheaders"
                  :loading="tableLoader"
                  loading-text="Loading... Please wait"
                  :items="filteredStudents"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  hide-default-footer
                >
                  <template v-slot:[`item.RegistrationDate`]="{ item }">
                    <span class="table_style_one">
                      {{
                        item.RegistrationDate?.split("T")[0].replaceAll(
                          "-",
                          "/"
                        )
                      }}
                    </span>
                  </template>
                  <template v-slot:[`item.Monitor`]="{ item }">
                    <span class="table_style_one">
                      {{ item.Monitor ? "Yes" : "No" }}
                    </span>
                  </template>
                  <template v-slot:[`item.ManualPaid`]="{ item }">
                    <span class="table_style_one">
                      {{ item.ManualPaid ? "Yes" : "No" }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-checkbox
                      v-if="item.ManualPaid == false && item.Monitor == false"
                      v-model="PayRoyaltiesSelectedCheckBox"
                      :value="item.StudentId"
                    ></v-checkbox>
                    <v-icon v-else>mdi-check</v-icon>
                  </template>
                </v-data-table>
              </v-card>
              <template>
                <div class="mt-4">
                  <span style="font-weight: bold">
                    Royalty Cost:
                    {{ GetStudents?.Data?.RoyaltyAgreementFee }} USD</span
                  >
                </div>
                <div class="">
                  <span style="font-weight: bold">
                    Total Cost: {{ totalRoyaltyCost }} USD</span
                  >
                </div>
              </template>
            </v-card>
          </div>
          <v-card-actions class="px-8 pb-10 d-flex justify-space-between">
            <div class=" ">
              <div class="">
                <span> To proceed, click CHECKOUT.</span>
              </div>
              <div class="">
                <span
                  >After payment, students will receive their digital
                  Manual.</span
                >
              </div>
            </div>
            <div class="d-flex justify-end">
              <v-btn
                color="transparent"
                depressed
                @click="close"
                ><span class="text_style">Cancel</span></v-btn
              >
              <v-btn
                color="primary"
                class="px-14 py-4 ml-5"
                depressed
                @click="openNextProcessDialog('royalty')"
                ><span v-if="btnloader != true" class="text_style"> Next </span>
                <!-- @click="GoToStepTwo('royalty')" -->
                <v-progress-circular
                  indeterminate
                  size="20"
                  v-else
                  class="px-5"
                  color="white"
                  v-show="btnloader"
                ></v-progress-circular
              ></v-btn>
            </div>
          </v-card-actions>
        </div>
        <div v-show="stepTwo" class="px-6 py-4">
          <div class="d-flex justify-space-between align-center mb-6">
            <div>
              <span style="font-size: 24px">Billing Address</span>
            </div>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <v-row class="pa-2" style="display: flex; flex-wrap: wrap">
            <v-col cols="12" lg="7" md="7" class="ordering-payments" style="">
              <v-card max-width="550" flat>
                <v-row class="mt-4">
                  <v-col cols="12" md="6">
                    <p><b> First Name</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.FirstName"
                      :error-messages="
                        $v.form.BillingDetails.FirstName.$error
                          ? form.BillingDetails.FirstName == ''
                            ? 'First Name is required'
                            : 'First Name only contain alphabetic characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>Last Name</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.LastName"
                      :error-messages="
                        $v.form.BillingDetails.LastName.$error
                          ? form.BillingDetails.LastName == ''
                            ? 'Last Name is required'
                            : 'Last Name only contain alphabetic characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <p><b>Street Address</b></p>
                <v-text-field
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  v-model="form.BillingDetails.StreetAddress1"
                  :error-messages="
                    $v.form.BillingDetails.StreetAddress1.$error
                      ? 'Street Address is required'
                      : null
                  "
                >
                </v-text-field>
                <v-text-field
                  outlined
                  flat
                  dense
                  single-line
                  append-icon="mdi-check"
                  v-model="form.BillingDetails.StreetAddress2"
                >
                </v-text-field>
                <v-row class="my-0 py-0">
                  <v-col cols="12" md="6">
                    <p><b> City</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.City.$error
                          ? form.BillingDetails.City == ''
                            ? 'City is required'
                            : 'City only contain alphabetic characters'
                          : null
                      "
                      v-model="form.BillingDetails.City"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>State / Province / Region</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.Province.$error
                          ? 'State or Province is required'
                          : null
                      "
                      v-model="form.BillingDetails.Province"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <p><b> Zip Code</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      v-model="form.BillingDetails.ZipCode"
                      :error-messages="
                        $v.form.BillingDetails.ZipCode.$error
                          ? form.BillingDetails.ZipCode == ''
                            ? 'Zip Code is required'
                            : 'Zip Code only contain alphabetic and numeric characters'
                          : null
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p><b>Country / Region</b></p>
                    <v-text-field
                      single-line
                      outlined
                      flat
                      solo
                      dense
                      :error-messages="
                        $v.form.BillingDetails.Country.$error
                          ? 'Country is required'
                          : null
                      "
                      v-model="form.BillingDetails.Country"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <div class="mt-8"><b>Phone Number</b></div>
                <v-text-field
                  single-line
                  outlined
                  class="mt-5"
                  flat
                  solo
                  dense
                  maxlength="17"
                  minlength="7"
                  v-model="form.BillingDetails.PhoneNumber"
                  :error-messages="
                    getErrorMessage('PhoneNumber', 'PhoneNumber')
                  "
                >
                </v-text-field>
                <v-divider class="divider mt-9"></v-divider>
                <div class="my-8" style="font-size: 24px">
                  <b>Credit Card Information</b>
                </div>
                <div>
                  <v-row>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Name on Card:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            dense
                            outlined
                            :error-messages="
                              getErrorMessageCardHolderName(
                                form.PaymentCard.CardHolderName
                              )
                            "
                            v-model="form.PaymentCard.CardHolderName"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Card Number:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            maxlength="16"
                            :error-messages="
                              getErrorMessageCardNumber(
                                form.PaymentCard.CardNumber
                              )
                            "
                            v-model="form.PaymentCard.CardNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="my-7">
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">CVV Code:</div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            :maxlength="form.PaymentCard.CardNumber?.length === 15 ? 4 : 3" 
                            :error-messages="
                              getErrorCardNumberCvv(form.PaymentCard.CardCVV)
                            "
                            v-model="form.PaymentCard.CardCVV"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-1">
                      <v-row>
                        <v-col cols="4">
                          <div class="mr-3 d-flex align-center">
                            Expiration Date:
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            class=""
                            label="MM/YY"
                            maxlength="5"
                            dense
                            outlined
                            single-line
                            v-model="form.PaymentCard.CardExp"
                            @input="formatExpiryDate"
                            :error-messages="
                              getErrorMessageExpiryDate(
                                form.PaymentCard.CardExp
                              )
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
                <div class="d-flex justify-space-between mt-11">
                  <div>
                    <v-btn
                      color="primary"
                      class="px-9"
                      v-show="this.stepTwo == true"
                      @click="GoBack()"
                      >Back</v-btn
                    >
                  </div>
                  <div>
                    <v-btn
                      color="primary"
                      :disabled="submitBtnloader"
                      class="px-9"
                      @click="Submit()"
                      ><span v-if="submitBtnloader != true">Submit</span
                      ><v-progress-circular
                        indeterminate
                        size="20"
                        v-else
                        class="px-5"
                        color="white"
                        v-show="submitBtnloader"
                      ></v-progress-circular
                    ></v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="5" md="5" class="ordering-summary" style="">
              <v-card flat outlined>
                <span class="pt-4 d-flex justify-center head-primary"
                  >MANUAL DETAILS</span
                >
                <v-divider class="devider"></v-divider>
                <span class="mx-5 d-flex font-18 mb-2" style="font-weight: bold"
                  >Manual Amount:
                  {{ form.TotalAmount }}
                </span>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
// import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";
import {
  required,
  minLength,
  maxLength,
  numeric,
  // email,
  // alpha,
} from "vuelidate/lib/validators";

const alphaWithSpaces = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s]+$/.test(value);
};
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const allowDigitsAndSteric = (value) => {
  if (!value) return true;
  return /^[0-9*]+$/.test(value); // to allow digits and *
};
export default {
  name: "SaminarCourseComponent",
  // components: {
  //   SuccessToastComponent,
  //   ErrorToastComponent,
  // },

  computed: {
    ...mapGetters(["GetStudents","GetLoggedInUser"]),
    filteredStudents() {
      return this.GetStudents.Data?.Students.filter(
        (student) => student.GraduationDate === null
      );
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetStudents?.Data?.Students?.length
        : this.itemsPerPage;
    },
    isManualPayment() {
      if (
        this.GetStudents.Data?.RoyaltyAgreementFee > 0 &&
        this.GetStudents.Data?.RoyaltyAgreementFee !== null
      ) {
        return false;
      }
      if (
        this.GetStudents.Data?.ManualFee?.DigitalManualInstructorFee > 0 &&
        this.GetStudents.Data?.ManualFee?.DigitalManualInstructorFee !== null
      ) {
        return true;
      }
      return false;
    },
    isRoyaltyPayment() {
      if (
        this.GetStudents.Data?.RoyaltyAgreementFee > 0 &&
        this.GetStudents.Data?.RoyaltyAgreementFee !== null
      ) {
        return true;
      }
      return false;
    },
    totalRoyaltyCost() {
      return (
        this.PayRoyaltiesSelectedCheckBox.length *
        this.GetStudents.Data?.RoyaltyAgreementFee
      );
    },
    totalManualCost() {
      return (
        this.PurchaseDigitalManualsCheckBox.length *
        this.GetStudents.Data?.ManualFee?.DigitalManualInstructorFee
      );
    },
    formattedEmailList() {
      if (!this.GetStudents.Data?.Students) return '';
      
      // Extract emails and filter out empty/null values
      const emails = this.GetStudents?.Data?.Students
        .map(student => student.Email)
        .filter(email => email && email.trim() !== '');
      
      return emails.join(',\n');
    },
  },
  data() {
    return {
      isFormSubmitted: false,
      stepTwo: false,
      stepOne: true,
      submitBtnloader: false,
      PayRoyaltiesSelectedCheckBox: [],
      PurchaseDigitalManualsCheckBox: [],
      emailForm: {
        SeminarId: 0,
        Subject: "",
        Body: "",
      },
      manualRoyaltyPaymentForm: {
        UserIds: null,
        SeminarId: 0,
      },
      form: {
        TotalAmount: 0,
        IsManualPayment: true,
        StudentIds: null,
        SeminarId: 0,
        BillingDetails: {
          FirstName: "",
          LastName: "",
          StreetAddress1: "",
          StreetAddress2: "",
          City: "",
          Province: "",
          ZipCode: "",
          Country: "",
          PhoneNumber: "",
          UserId: null,
        },
        PaymentCard: {
          PaymentCardId: 0,
          PaymentType: 1,
          CardHolderName: "",
          CardNumber: "",
          CardExp: "",
          CardCVV: "",
        },
      },

      courseName: this.$store.state.courseName,
      seminarId: null,
      studentId: null,
      studentName: "",
      PreviewEmailStudentDialog: false,
      SuccessGraducatedDialog: false,
      selectedStudentCheckbox: [],
      GraduateStudentDialog: false,
      btnloader: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      selectStudentForSeminar: "Butt sab",
      selectStudentForSeminarArray: [
        "Jamshaid",
        "Talha",
        "Butt sab",
        "daniyal",
        "Hashaam",
      ],
      addStudentdialog: false,
      EmailStudentDialog: false,
      CopyStudentEmailsDialog: false,
      studentInfoDialog: false,
      selectedStudent: null,
      editdialog: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      headers: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email", sortable: false },
        { text: "Membership Level", value: "MembershipLevel" },
       
        { text: "Registration date", value: "RegistrationDate" },
        // { text: "Member Renewal Date", value: "memberrenewaldate" },
        { text: "Monitor", value: "Monitor" },
        { text: "Royalty Paid", value: "PaidAmount" },
        { text: "Graduation Date", value: "GraduationDate" },

        { text: "", value: "actions", sortable: false },
      ],
      headerGraduateStudent: [
        { text: "Student Name", value: "Name" },
        { text: "Membership Level", value: "MembershipLevel" },
        { text: "Registration date", value: "RegistrationDate" },
        { text: "Monitor", value: "Monitor" },
        { text: "Manual/Royalty Fee paid", value: "ManualPaid" },
        { text: "Graduate", value: "actions", sortable: false },
      ],
      PayRoyalheaders: [
        { text: "Student Name", value: "Name" },
        { text: "Membership Level", value: "MembershipLevel" },
        { text: "Registration date", value: "RegistrationDate" },
        { text: "Monitor", value: "Monitor" },
        { text: "Royalty Due", value: "ManualPaid" },
        { text: "Purchase", value: "actions", sortable: false },
      ],
      downloadDataTableOne: [],
      ManualPaymentDialog: false,
      allStudentsForManualPayment: [],
      GraduateDialog: false,
      openNextDialog: false,
      totalCost: 0,
      totalCostRoyalty: 0,
    };
  },
  validations: {
    emailForm:{
      Subject: {
        required,
      },
      Body: {
        required,
      },
    },
    form: {
      BillingDetails: {
        FirstName: {
          required,
          alpha: alphaWithSpaces,
        },
        LastName: {
          required,
          alpha: alphaWithSpaces,
        },
        StreetAddress1: {
          required,
        },
        City: {
          required,
          alpha: alphaWithSpaces,
        },
        Province: {
          required,
        },
        ZipCode: {
          required,
        },
        Country: {
          required,
        },
        PhoneNumber: {
          required,
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(17),
        },
      },
      PaymentCard: {
        CardHolderName: {
          required,
          alpha: alphaWithSpacesAndSpecialChars,
        },
        CardNumber: {
          required,
          numeric,
          minLength: minLength(15),
        },
        CardExp: {
          required,
          expiryDate(value) {
            if (!value) {
              return "Expiry date is required.";
            }

            const [month, year] = value.split("/");
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;

            if (
              parseInt(month) >= 1 &&
              parseInt(month) <= 12 &&
              parseInt(year) >= currentYear &&
              ((parseInt(year) === currentYear &&
                parseInt(month) >= currentMonth) ||
                parseInt(year) > currentYear)
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        CardCVV: {
          required, allowDigitsAndSteric: allowDigitsAndSteric, minLength: minLength(3)
        },
      },
    },
  },
  mounted() {
    this.seminarId = this.$route.params.id;
    this.tableLoader = true;
    setTimeout(() => {
      (this.downloadDataTableOne = [
        {
          name: "Founders Session Intensive",
          Id: 1,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
        {
          name: "Founders Session Intensive",
          Id: 2,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
        {
          name: "Founders Session Intensive",
          Id: 3,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
        {
          name: "Founders Session Intensive",
          Id: 4,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
        {
          name: "Founders Session Intensive",
          Id: 5,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
        {
          name: "Founders Session Intensive",
          Id: 6,
          membershiplevel: "Access",
          paid: "$1500",
          registrationdate: "11/12/2021",
          memberrenewaldate: "11/12/2021",
          graduation: "12/02/2023",
          monitor: "Yes",
          selected: false,
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
    this.fetchData();
    this.form.SeminarId = Number(this.seminarId);
    this.emailForm.SeminarId = Number(this.seminarId);
    this.form.BillingDetails.UserId = this.GetLoggedInUser.Id;
  },
  methods: {
    getErrorMessage(fieldName) {
      const errorMessages = {
        FirstName: {
          required: "First name is required",
          alpha: "First name only contains alphabetic characters.",
        },
        LastName: {
          required: "Last name is required",
          alpha: "Last name only contains alphabetic characters.",
        },
        StreetAddress1: {
          required: "Street address is required",
        },
        City: {
          required: "City is required",
          alpha: "City only contains alphabetic characters.",
        },
        ZipCode: {
          required: "Zip code is required",
        },
        Country: {
          required: "Country is required",
          alpha: "Country only contains alphabetic characters.",
        },
        Province: {
          required: "Province is required",
          alpha: "Province only contains alphabetic characters.",
        },
        PhoneNumber: {
          required: "Phone number is required",
          numeric: "Phone number should be only numeric characters",
          minLength: "Phone number should be minimum of 7 digits",
        },
      };
      const errorField = this.$v.form.BillingDetails[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    getErrorMessageCardHolderName(field) {
      if (this.$v.form.PaymentCard.CardHolderName.$error == false) {
        return null;
      }
      if (!field) {
        return "Card holder name is required";
      }
      if (!this.$v.form.PaymentCard.CardHolderName.alpha) {
        return "Only alphabetical characters are allowed.";
      }
      return null;
    },
    getErrorMessageCardNumber(field) {
      if (this.$v.form.PaymentCard.CardNumber.$error == false) {
        return null;
      }
      if (field == null || field == "") {
        return "Card number is required";
      }
      if (!this.$v.form.PaymentCard.CardNumber.numeric) {
        return "Only numeric digits are allowed";
      }
      if (!this.$v.form.PaymentCard.CardNumber.minLength) {
        return "Minimum of 15 digits are required";
      }
      return "Invalid card number.";
    },
    getErrorMessageExpiryDate(field) {
      if (this.$v.form.PaymentCard.CardExp.$error == false) {
        return null;
      }
      if (!field) {
        return "Expiry date is required";
      }
      return "Invalid expiry date.";
    },
    // getErrorCardNumberCvv(field) {
    //   if (this.$v.form.PaymentCard.CardCVV.$error == false) {
    //       return null;
    //     }
    //     if (field == null || field == "") {
    //       return "CVV is required";
    //     }
    //     if (!this.$v.form.PaymentCard.CardCVV.allowDigitsAndSteric) {
    //       return "Only numeric digits are allowed.";
    //     }
    //     if (!this.$v.form.PaymentCard.CardCVV.minLength) {
    //       return "Minimum of 3 digits are required";
    //     }
    //   return "Invalid card cvv.";
    // },
    getErrorCardNumberCvv(field) {
      if (!this.isFormSubmitted) {
        return null; // Do not show errors if the form hasn't been submitted
      }
      const cardLength = this.form.PaymentCard.CardNumber?.length;
      const validCvvLength = cardLength === 15 ? 4 : 3;

      if (!field) {
        return `CVV is required`;
      }
      if (field.length !== validCvvLength) {
        return `CVV must be ${validCvvLength} digits long`;
      }
      if (!this.$v.form.PaymentCard.CardCVV.allowDigitsAndSteric) {
        return "Only numeric digits are allowed";
      }

      return null;
    },
    formatExpiryDate() {
      if (
        this.form.PaymentCard.CardExp.length === 2 &&
        !this.form.PaymentCard.CardExp.includes("/")
      ) {
        this.form.PaymentCard.CardExp += "/";
      }
    },

    RoyaltyManualPayment(text) {
      if (this.GetStudents.Data.CanPay) {
        if (text == "Manual") {
          this.fetchAllStudents();
          this.ManualPaymentDialog = true;
          this.stepOne = true;
        }
        if (text == "Royalty") {
          this.fetchAllStudents();
          this.GraduateDialog = true;
          this.stepOne = true;
        }
      } else {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `You can pay after ${
            this.GetStudents.Data.PayAfter?.split("T")[0]
          }`,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    fetchAllStudents() {
      const obj = {
        Id: this.seminarId,
        page: 1, 
        pageSize: "All", 
      };
      
      this.$store.dispatch("GetStudents", obj).then((res) => {
        this.allStudentsForManualPayment = res.Students.filter(
          (student) => student.GraduationDate === null
        ) || []; // Store all students
      });
    },
    async openCopyStudentEmailsDialog() {
      this.CopyStudentEmailsDialog = true;
      try {
        const obj = {
          Id: this.seminarId,
          page: 1,
          pageSize: "All",
        };
        await this.$store.dispatch("GetStudents", obj);
      } catch (error) {
        console.error('Error fetching all students:', error);
      }
    },
    copyWithModernAPI() {
      // Use the modern Clipboard API if available
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.formattedEmailList)
          .then(() => {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Emails copied to clipboard!",
              showConfirmButton: false,
              timer: 2000,
            });
          })
          .catch(err => {
            console.error('Clipboard API failed: ', err);
            this.showCopyError();
          });
      } else {
        this.showCopyError();
      }
    },
    showCopyError() {
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to copy emails. Please select and copy manually.",
        showConfirmButton: false,
        timer: 3000,
      });
    },
    openStudentDialog(student) {
      this.selectedStudent = student;
      this.studentInfoDialog = true;
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    
    GraduateStudent() {
      if (this.GetStudents.Data.CanGraduate) {
        this.GraduateStudentDialog = true;
      } else {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `You can graduate students after ${
            this.GetStudents.Data.GraduteAfter?.split("T")[0]
          }`,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    handleGraduateStudents() {
      if (this.selectedStudentCheckbox.length == 0) {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `Must select at least one student.`,
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      this.btnloader = true;
      const obj = {
        SeminarId: this.seminarId,
        StudentIds: this.selectedStudentCheckbox,
      };
      this.$store.dispatch("GraduateStudents", obj).then(() => {
        this.btnloader = false;
        this.SuccessGraducatedDialog = true;
        this.GraduateStudentDialog = false;
        this.fetchData();
      });
    },
    fetchData() {
      const obj = {
        Id: this.seminarId,
        page: this.page,
        pageSize: this.itemsPerPage,
      };
      this.$store.dispatch("GetStudents", obj).then((res) => {
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
    },
    GoToStepTwo(name) {
      if (
        (this.totalManualCost == 0 && name == "manual") ||
        (this.totalRoyaltyCost == 0 && name == "royalty")
      ) {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `Check atleast one ${name}`,
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      this.form.SeminarId = Number(this.seminarId);
      this.form.StudentIds =
        name == "manual"
          ? this.PurchaseDigitalManualsCheckBox
          : this.PayRoyaltiesSelectedCheckBox;
      this.form.TotalAmount =
        name == "manual" ? this.totalManualCost : this.totalRoyaltyCost;
      (this.stepOne = false), (this.stepTwo = true);
    },
    resetForms() {
      this.form = {
        BillingDetails: {
          Id: 0,
          FirstName: "",
          LastName: "",
          StreetAddress1: "",
          StreetAddress2: "",
          City: "",
          Province: "",
          ZipCode: "",
          Country: "",
          PhoneNumber: "",
        },
        PaymentCard: {
          CardHolderName: "",
          CardNumber: "",
          CardExp: "",
          CardCVV: "",
        },
      };
    },

    GoBack() {
      this.stepTwo = false;
      this.stepOne = true;
      // this.resetForms();
    },
    openNextProcessDialog(name) {
      if (
        (this.totalManualCost == 0 && name == "manual") ||
        (this.totalRoyaltyCost == 0 && name == "royalty")
      ) {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `Check atleast one ${name}`,
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else {
        this.openNextDialog = true
        this.manualRoyaltyPaymentForm.SeminarId = Number(this.seminarId);
        this.manualRoyaltyPaymentForm.UserIds =
        name == "manual"
          ? this.PurchaseDigitalManualsCheckBox
          : this.PayRoyaltiesSelectedCheckBox;
      }
    },
    ManualRoyaltyPayment(){
      this.$store.dispatch("ManualRoyaltyPay", this.manualRoyaltyPaymentForm).then((res) => {
          if (res.Status) {
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Royalty marked as paid successfully.",
              showConfirmButton: false,
              timer: 1500,
            });
            this.close()
            this.fetchData()
          }else{
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Payment Failure",
              showConfirmButton: false,
              timer: 1500,
            });
            this.close()
            this.fetchData()
          }
        });
    },
    Submit() {
      this.isFormSubmitted = true;
      this.$v.form.$touch();
      if(this.$v.form.$invalid){
        return
      }
      this.submitBtnloader = true;
        this.$store.dispatch("PaySeminarManual", this.form).then((res) => {
          if (res.Status) {
            this.submitBtnloader = false;
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "SeminarManual Payment Successfully",
              showConfirmButton: false,
              timer: 1500,
            });
            this.close()
            this.fetchData()
          }else{
            this.submitBtnloader = false;
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Payment Failure",
              showConfirmButton: false,
              timer: 1500,
            });
            this.close()
            this.fetchData()
          }
        });



    },
    close() {
      this.openNextDialog = false;
      this.GraduateDialog = false;
      this.ManualPaymentDialog = false;
      this.stepOne = false;
      this.stepTwo = false;
      this.PayRoyaltiesSelectedCheckBox = []
      this.PurchaseDigitalManualsCheckBox = []
      this.resetForms();
    },
    closeEmailModule(){
      this.emailForm.Subject = '';
      this.emailForm.Body = '';
      this.$v.emailForm.$reset()
      this.EmailStudentDialog = false
      this.PreviewEmailStudentDialog = false
    },
    checkValidateState() {
      this.$v.emailForm.$touch();
      if (this.$v.emailForm.$invalid) {
        return;
      } else {
        this.PreviewEmailStudentDialog = true;
        this.EmailStudentDialog = false;
      }
    },
    deleteStudent(item) {
      this.studentId = item.StudentId;
      this.studentName = item.Name;
      this.dialog = true;
    },
    SelectAllStudent() {
      this.selectedStudentCheckbox = [1, 2, 3, 4, 5, 6];
    },
    toggleIsPlaying(obj) {
      this.downloadDataTableOne = this.downloadDataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;
          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    DdialogClose() {
      this.btnloader = true;
      const obj = {
        Id: this.studentId,
        seminarId: this.seminarId,
      };
      this.$store.dispatch("DeleteStudents", obj).then(() => {
        this.dialog = false;
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Delete successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.fetchData();
      });
      // this.ErrorToast = true;
      // setTimeout(() => {
      //   this.ErrorToast = false;
      // }, 1500);
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      this.btnloader = true;
      const form = new FormData();
      form.append('SeminarId', this.emailForm.SeminarId);
      form.append('Subject', this.emailForm.Subject);
      form.append('Body', this.emailForm.Body);
      this.$store.dispatch("SendEmailToStudents",form).then(() => {
        this.btnloader = false;
        this.addStudentdialog = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Email sent successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.closeEmailModule()
      });
      // setTimeout(() => {
      //   this.btnloader = true;
      // }, 100);
      // setTimeout(() => {
      //   this.addStudentdialog = false;
      //   this.EmailStudentDialog = false;
      //   this.PreviewEmailStudentDialog = false;
      //   this.GraduateStudentDialog = false;
      //   // this.btnloader = false;
      //   this.uploadfiledialog = false;
      //   this.createnewgroupdialog = false;
      //   this.SuccessToast = true;
      // }, 2000);
      // setTimeout(() => {
      //   this.SuccessToast = false;
      // }, 3000);
    },
  },
};
</script>
<style scoped>
.ordering-payments {
  order: 2;
  flex-grow: 2;
}
.ordering-summary {
  order: 1;
  flex-grow: 1;
}
.head-primary {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #0071bd;
}
.devider {
  background: #ffffff;
  border: 1px solid #7e7272;
}
.font-18 {
  font-size: 18px;
}
.graduate-btn{
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.email-list {
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
}
@media (min-width: 768px) {
  .ordering-payments {
    order: 1;
    flex-grow: 1;
    padding-right: 0;
    padding-left: 0;
    padding-top: 0;
  }
  .ordering-summary {
    order: 2;
    flex-grow: 2;
  }
  .graduate-btn{
    padding-left: 56px;
    padding-right: 56px;
  }
}
</style>